import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import * as PR from "../../prime-modules/index";
import { Link } from 'react-router-dom';
import { useMutation } from "react-query";
import { otpApi } from "../../services/affiliateApi";
import { useDispatch, useSelector } from "react-redux";
import { afLoginReducer } from "../../store/afAuth.slice";
import { customInput } from "../../utils/reuse";
import { globalConfig } from "../../constants";

const TwoFactorAuthentication = ({loginResponse,email,password,loginMutate, toast}) => {
  const appName = process.env.REACT_APP_NAME;
  const isCorporate = appName?.includes("corporate");
  const { affiliate } = useSelector(state => state.language?.activelang);
    const dispatch = useDispatch();
    const [otp, setOTP] = useState(undefined);
    const [timer, setTimer] = useState(0);
    const {isLoading,mutate} = useMutation(otpApi,{
      onSuccess:o=>{
        dispatch(afLoginReducer(o))
      },
      onError: o => {
        toast.current.show({ severity: 'error',life:globalConfig?.errorToastDisplayTime, summary: 'Error', detail:o.message })
      }
    });

    useEffect(() => {
      if (!!otp && otp.length === 6) {
        mutate({ code: otp, passKey: loginResponse?.passkey || "" });
      }
    }, [otp, mutate, loginResponse.passkey]);

    useEffect(() => {
      let interval;
  
      if (timer > 0) {
        interval = setInterval(() => {
          setTimer(prev => prev - 1);
        }, 1000);
      }
  
      return () => clearInterval(interval); // cleanup
    }, [timer]);

    const handleResend = ()=>{
      if(timer === 0){
      loginMutate({email,password}) 
      setTimer(30)
      }
 
    }

    return (
      <>
          <section className="signup-section">
            <div className="grid">
                <div className="col-12 text-center">
                    <h1>{isCorporate ? affiliate?.AFFNL0145 : affiliate?.AFFNL0043}</h1>
                    <p>{affiliate?.AFFNL0064 || "Two-Factor Authentication"}</p>
                    <div className="signup-wrapper two-fa">
                        {/* Form section starts here */}
                        <p>{affiliate?.AFFNL0065 || "Please enter the One Time Password (OTP) received on your email below"}</p>
                        <Formik initialValues={{otp: ''}}>
                            <Form autoComplete="off" className="form-block">
                                <div className='grid mt-4'>
                                    <div className="col-12 md:col-12">
                                        <PR.InputOtp value={otp} onChange={(e) => setOTP(e.value)} integerOnly length={6} inputTemplate={customInput}/>
                                    </div>
                                    <div className="col-12 mt-3">
                                        <PR.Button disabled={!otp || otp.length !== 6 || isLoading} onClick={()=>mutate({code:otp,passKey:loginResponse?.passkey})} label={affiliate?.AFFNL0024} type='submit' className="signup-button w-12"/>
                                    </div>
                                    <div className="col-12 mt-3 text-center">
                                        <Link onClick={()=>handleResend()}>{affiliate?.AFFNL0123 || "Resend"} {timer !== 0 ? <span>({timer})</span>:""}</Link>
                                    </div>
                                </div>
                            </Form>
                        </Formik>
                    </div>
                </div>
            </div>
          </section>
      </>
    );
};

export default TwoFactorAuthentication;
